<template>
  <v-dialog
    v-model="dialog"
    persistent
    fullscreen
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        v-bind="$attrs"
        v-on="on"
      >
        {{ getLabel }}
        <v-icon>
          {{ getIcon }}
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        {{ getTitle }}
        <v-spacer />
        <v-btn
          color="primary"
          text
          icon
          @click="close()"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <iframe
        id="preview"
        sandbox="allow-popups"
        frameborder="0"
        width="100%"
        style="min-height: 800px"
        :srcdoc="html"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PreviewModal',
  props: {
    label: {
      type: String,
      default: 'preview',
    },
    icon: {
      type: String,
      default: 'mdi-eye',
    },
    title: {
      type: String,
      default: 'Visualizar',
    },
    value: {
      type: [String, Number, undefined, null],
      default: '',
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    getLabel() {
      return this.label;
    },
    getIcon() {
      return this.icon;
    },
    getTitle() {
      return this.title;
    },
    html() {
      return this.value;
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
};
</script>
